// extracted by mini-css-extract-plugin
export var cardTitle = "_ie-1";
export var commentBubble = "_ie-e";
export var commentForm = "_ie-a";
export var commentInput = "_ie-b";
export var commentLabel = "_ie-d";
export var commentPrompt = "_ie-9";
export var csatCard = "_ie-0";
export var feedbackSection = "_ie-7";
export var starDisabled = "_ie-6";
export var starEmpty = "_ie-5";
export var starFilled = "_ie-4";
export var starWrapper = "_ie-3";
export var starsContainer = "_ie-2";
export var submittedComment = "_ie-c";
export var thankYouText = "_ie-8";